// @flow

import React from "react";
import {useFormik} from "formik";
import {useObserver} from "mobx-react-lite";
import {Input, Form, Modal, Select} from "antd";

import {createCallRecordValidation} from "./createCallRecordValidation";
import {useStore} from "../../../../../../hooks/useStore";

export const CreateCallRecordModal = ({
    isVisible,
    setVisible,
    courierId,
    callStatuses,
    onComplete
}) => {
    const stores = useStore();
    const formik = useFormik({
        initialValues: {
            courierId,
            callStatus: undefined,
            comment: undefined
        },
        validationSchema: createCallRecordValidation,
        onSubmit: async values => {
            const result = await stores.courierStore.createCourierCallRecords(values);
            if (result) {
                resetForm();
                await onComplete();
                setVisible(false);
            }
        },
        enableReinitialize: true
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        resetForm,
        setFieldValue
    } = formik;

    return useObserver(() => (
        <React.Fragment>
            <Modal
                visible={isVisible}
                centered
                title={"Yeni Arama Kaydı Oluştur"}
                okText={"Oluştur"}
                onOk={handleSubmit}
                confirmLoading={isSubmitting}
                cancelText={"İptal"}
                data-testid="createCallRecordModal"
                okButtonProps={{
                    "data-testid": "createCallRecordModal_submitButton"
                }}
                cancelButtonProps={{"data-testid": "createCallRecordModal_cancelButton"}}
                onCancel={() => {
                    resetForm();
                    setVisible();
                }}
            >
                <Form autoComplete="off" labelCol={{span: 24}} wrapperCol={{span: 24}}>
                    <Form.Item
                        colon={false}
                        label={"Arama Durumu"}
                        labelAlign="left"
                        validateStatus={
                            errors.callStatus && touched.callStatus ? "error" : "success"
                        }
                        help={errors.callStatus && touched.callStatus ? errors.callStatus : null}
                    >
                        <Select
                            showSearch
                            name="callStatus"
                            value={values.callStatus}
                            onChange={value => setFieldValue("callStatus", value)}
                        >
                            {Object.entries(callStatuses).map(([key, value]) => (
                                <Select.Option key={key} value={key}>
                                    {value}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        colon={false}
                        label={"Detay"}
                        labelAlign="left"
                        validateStatus={errors.comment && touched.comment ? "error" : "success"}
                        help={errors.comment && touched.comment ? errors.comment : null}
                    >
                        <Input.TextArea
                            rows={5}
                            name="comment"
                            value={values.comment}
                            onChange={handleChange}
                            data-testid="comment"
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    ));
};
